// store.js
import { configureStore } from '@reduxjs/toolkit';
import o365Reducer from './features/o365/O365Slice';
import historyReducer from './features/History/HistorySlice';
import organizationReducer from './features/Organization/OrganizationSlice';
import esetReducer from './features/Eset/EsetSlice';
import userReducer from './features/User/UserSlice';

export const store = configureStore({
  reducer: {
    o365: o365Reducer,
    history: historyReducer,
    organizations: organizationReducer,
    eset: esetReducer,
    users: userReducer,
  },
});
